import React from "react";
import Link from "next/link";
import { analyticsEvents, eventCategories, track } from "util/analytics";

import styles from "./styles.module.scss";

const ZeroState = () => {
  // track when this is displayed
  track(analyticsEvents.zero_state_viewed, eventCategories.search);
  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <p>Hmmm...nothing here</p>
        <picture>
          <img
            src="/nextpublic/square-foot-lightbulb@3x.png"
            alt="square-foot-lightbulb"
            className={styles.bulbImage}
          />
        </picture>
        <p className="title">
          Try something new, like searching in a different neighborhood
        </p>
      </div>
      <div className={styles.section}>
        <p className="bodyEmphasis">To help with your search:</p>
        <div className={styles.subSection}>
          <Link
            passHref
            target="_blank"
            href="/blog/office-space-per-employee/"
            className={styles.cardLink}
          >
            <div className={styles.card}>
              <div className={styles.imageContainer}>
                <picture>
                  <img
                    className={styles.image}
                    src="/nextpublic/marketing/blog/article-image@3x.png"
                    alt="office-1"
                  />
                </picture>
              </div>
              <div className={styles.inner}>
                <p className={styles.title}>
                  How Much Office Space Per Employee Do You Need?
                </p>
              </div>
            </div>
          </Link>
          <div className={styles.cardLink}>
            <Link
              passHref
              target="_blank"
              href="/blog/why-you-need-a-tenant-broker-in-your-office-search"
              className={styles.cardLink}
            >
              <div className={styles.card}>
                <div className={styles.imageContainer}>
                  <picture>
                    <img
                      className={styles.image}
                      src="/nextpublic/marketing/blog/article-image-2@3x.png"
                      alt="office-2"
                    />
                  </picture>
                </div>
                <div className={styles.inner}>
                  <p className={styles.title}>
                    Why You Need a Tenant Broker in Your Office Search
                  </p>
                </div>
              </div>
            </Link>
          </div>
        </div>
        <p className="bodyEmphasis">
          How SquareFoot helps brands find their space:
        </p>
        <div className={styles.subSection}>
          <div className={styles.cardLink}>
            <Link
              passHref
              target="_blank"
              href="/blog/ollies-new-office-space"
              className={styles.cardLink}
            >
              <div className={styles.card}>
                <div className={styles.imageContainer}>
                  <picture>
                    <img
                      className={styles.image}
                      src="/nextpublic/marketing/blog/ollie@3x.png"
                      alt="ollie-case-study"
                    />
                  </picture>
                </div>
                <div className={styles.inner}>
                  <p className={styles.title}>
                    SquareFoot used FLEX to find Ollie their ideal office space
                  </p>
                </div>
              </div>
            </Link>
          </div>
          <div className={styles.cardLink}>
            <Link
              passHref
              target="_blank"
              href="/blog/client-spotlight-credsimple"
              className={styles.cardLink}
            >
              <div className={styles.card}>
                <div className={styles.imageContainer}>
                  <picture>
                    <img
                      className={styles.image}
                      src="/nextpublic/marketing/blog/office@3x.png"
                      alt="CredSimple-case-study"
                    />
                  </picture>
                </div>
                <div className={styles.inner}>
                  <p className={styles.title}>
                    SquareFoot helped CredSimple lease an office with room to
                    grow
                  </p>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ZeroState;
